/**
 * Lire une date qui vient de la base (écart E78, 2026-09-25).
 *
 * ⚠️ La base et le serveur tournent en UTC. Une heure écrite en TEXTE sans fuseau
 * (`2026-09-25T12:53:26`) est lue par `new Date()` comme une heure LOCALE —
 * c'est-à-dire de Paris : l'écran affichait 12:53 à 14:53. Les historiques des
 * dossiers écrits avant le 2026-09-25 sont dans ce cas (72 entrées mesurées), et
 * ils sont immuables : on ne les réécrit pas, on les LIT correctement.
 *
 * Une date seule (`2026-09-25`) et une heure qui porte déjà son fuseau (« Z »,
 * « +02:00 ») passent telles quelles.
 */
const SANS_FUSEAU = /^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}(:\d{2}(\.\d+)?)?$/;

export function versDate(v) {
    if (v === null || v === undefined || v === '') return null;
    if (v instanceof Date) return v;
    const s = String(v);
    const d = new Date(SANS_FUSEAU.test(s) ? s.replace(' ', 'T') + 'Z' : s);
    return Number.isNaN(d.getTime()) ? null : d;
}
